import React, { useState, useRef, useEffect, useContext } from 'react';
import api from "../../../../services/api";
import { usePersistedState } from '../../../../hooks/index'

import NotificationAlert from "react-notification-alert";
import Filters from './Filters'
import SimpleHeader from '../../../../components/Headers/SimpleHeader'
import Table from './Table';
import {
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Col,
} from "reactstrap";


export default ({ ...props }) => {

    const [loading, setLoading] = useState(false)
    const [alert, setAlert] = useState(null)
    const [currentPage, setCurrentPage] = usePersistedState('page', 1)
    const [currentPerPage, setCurrentPerPage] = usePersistedState('perPage', 10)
    const [publicacoes, setPublicacoes] = useState([])
    const [pageProperties, setPageProperties] = useState({
        total: "0",
        perPage: 10,
        page: 1,
        lastPage: 1,
        loading: false,
        sortField: "data_postagem",
        sortOrder: 'asc',
        sort: new Map([])
    })
    const [lastSearch, setLastSearch] = useState({})
    const notificationAlert = useRef();

    function notify(type, msg) {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        if (notificationAlert) notificationAlert.current.notificationAlert(options);
    };

    async function updatePageProperties({ response, sortField, sortOrder }) {
        const { total, perPage, page, lastPage } = await response.data
        setPageProperties({
            ...pageProperties,
            total,
            perPage,
            page,
            lastPage,
            loading: false,
            sortField,
            sortOrder
        })
    }

    async function loadPublicacoes(page = 1,
        limit = 10,
        sortField = pageProperties.sortField,
        sortOrder = pageProperties.sortOrder,
        filters = lastSearch) {
        setCurrentPage(page)
        setCurrentPerPage(limit)
        try {
            setPageProperties({
                ...pageProperties,
                loading: true
            })
            const response = await api.get(`marketing/publicacoes-prioridades/`, {
                params: {
                    page,
                    limit,
                    sortField,
                    sortOrder,
                    ...filters,
                }
            })
            setPublicacoes(response.data)
            await updatePageProperties({ response, sortField, sortOrder })
        } catch (err) {
            console.log(err.response)
            notify('danger', 'Houve um problema ao carregar as publicações.');
        }
    }

    const handleTableChange = async (type,
        { page,
            sizePerPage,
            sortField,
            sortOrder }) => {
        try {
            if (type == 'sort') {
                const value = pageProperties.sort.get(sortField)
                const newOrder = (value || 'asc') == 'desc' ? 'asc' : 'desc'
                const map = pageProperties.sort
                map.set(sortField, newOrder)
                sortOrder = newOrder
            }
            sortField = sortField == null ? undefined : sortField
            sortOrder = sortOrder == null ? undefined : sortOrder
            await loadPublicacoes(page == 0 ? 1 : page, sizePerPage, sortField, sortOrder)
        } catch (error) {
            console.error(error)
            notify('danger', 'Houve um problema ao carregar as publicações.');
        }
    }


    return (
        <>
            {alert}
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            <SimpleHeader name="Publicações vs Prioridades" parentName="Publicações" {...props} />
            <Container className="mt--6" fluid>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10,
                                }}>
                                <Filters
                                    title={<h1>Publicações vs Prioridades</h1>}
                                    data={publicacoes}
                                    load={(filters, clearPagination) => {
                                        setLastSearch(filters)
                                        loadPublicacoes(
                                            clearPagination ? 1 : currentPage,
                                            clearPagination ? 100 : currentPerPage,
                                            "data_postagem",
                                            "asc",
                                            filters)
                                    }}
                                    filtersPrioridades={{ ...lastSearch }}
                                />
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Table
                                            usuarios={publicacoes ? publicacoes.data : []}
                                            notify={notify}
                                            onTableChange={handleTableChange}
                                            history={props.history}
                                            pageProperties={pageProperties}
                                            loading={loading}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
